(() => {
  if (window.__soolerMobileMenuImageFallback) return;
  window.__soolerMobileMenuImageFallback = true;

  const selector = '[data-sooler-mobile-products-url]';
  const requestCache = new Map();

  const firstProductImage = (productsUrl) => {
    if (!requestCache.has(productsUrl)) {
      requestCache.set(
        productsUrl,
        fetch(productsUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Collection products request failed: ${response.status}`);
            return response.json();
          })
          .then((payload) => {
            const product = payload.products?.[0];
            const image = product?.image || product?.featured_image || product?.images?.[0];
            const source = typeof image === 'string' ? image : image?.src;
            if (!source) return null;
            const url = new URL(source, window.location.origin);
            url.searchParams.set('width', '720');
            return url.href;
          })
          .catch(() => null),
      );
    }
    return requestCache.get(productsUrl);
  };

  const hydrate = async (frame) => {
    if (frame.dataset.soolerImageState) return;
    frame.dataset.soolerImageState = 'loading';
    const source = await firstProductImage(frame.dataset.soolerMobileProductsUrl);
    if (!source) {
      frame.dataset.soolerImageState = 'empty';
      return;
    }

    const image = document.createElement('img');
    image.alt = '';
    image.decoding = 'async';
    image.loading = 'lazy';
    image.addEventListener('load', () => frame.classList.remove('is-empty'), { once: true });
    image.addEventListener('error', () => image.remove(), { once: true });
    frame.append(image);
    image.src = source;
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll?.(selector).forEach(hydrate);
    if (scope.matches?.(selector)) hydrate(scope);
  };

  initialize();
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) initialize(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
